import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

const getAuthToken = () => {
  return sessionStorage.getItem("token") || localStorage.getItem("token");
};

const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Save translation to history
export const saveTranslationToHistory = async (data) => {
  try {
    const response = await apiClient.post("/detectors/translator-save", data);
    return response.data;
  } catch (error) {
    console.error("Error saving translation:", error);
    throw error.response?.data || error;
  }
};

// Get translation history
export const getTranslationHistory = async (userId, machineId) => {
  try {
    const response = await apiClient.post("/detectors/translator-history", {
      userId,
      machineId
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching translation history:", error);
    throw error.response?.data || error;
  }
};

// Update translation
export const updateTranslation = async (id, translatedText, title) => {
  try {
    const response = await apiClient.put(`/detectors/translator-update/${id}`, {
      translatedText,
      title
    });
    return response.data;
  } catch (error) {
    console.error("Error updating translation:", error);
    throw error.response?.data || error;
  }
};

// Delete translation
export const deleteTranslation = async (id) => {
  try {
    const response = await apiClient.delete(`/detectors/translator-delete/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting translation:", error);
    throw error.response?.data || error;
  }
};

// Get translation statistics
export const getTranslationStats = async (userId, machineId) => {
  try {
    const params = new URLSearchParams();
    if (userId) params.append("userId", userId);
    if (machineId) params.append("machineId", machineId);
    const response = await apiClient.get(`/detectors/translator-stats?${params}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching translation stats:", error);
    throw error.response?.data || error;
  }
};